import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, ViewChild } from "@angular/core";
import { Searchbar } from "ionic-angular";
import { AlertController, NavController, NavParams, Platform/*, Popover, PopoverController*/ } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Member } from "../../models/interfaces/member.model";
import { Songs } from "../../models/interfaces/songs.model";
import { SongsAddPage } from "../../pages/songs/songs_add";
import { SongsViewPage } from "../../pages/songs/songs_view";
import { AuthService } from "../../providers/dbservice/authservice";
import { ConfigService } from "../../providers/dbservice/configservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";


@Component({
  selector: "page-songs",
  templateUrl: "songs.html",
})

export class SongsPage {
  @ViewChild('mySearchbar') searchbar: Searchbar;
  public static readonly SONGS_ADD_ACCESS = "addSongs";
  public static readonly SONGS_UPD_ACCESS = "updateSongs";
  public static readonly SONGS_DEL_ACCESS = "deleteSongs";
  public static readonly SONGS_VIEW_ACCESS = "viewSongs";
  private hasAddSongsAccess: boolean = false;
  private hasUpdSongsAccess: boolean = false;
  private hasDelSongsAccess: boolean = false;
  private songs$: any;
  private song: Songs;
  private st_id: number;
  private tmpSearchObject;
  private styleName: string ="";
  // This property will save the callback which we can unsubscribe when we leave this view
  public unsubscribeBackEvent: any;
  constructor(public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController, private db: DbserviceProvider, private configService: ConfigService,
    private platform: Platform,/* public popoverCtrl: PopoverController,*/
  ) {
    console.log("SongsPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.st_id = 2;
    if (this.authService.currentUser) {
      this.hasAddSongsAccess = this.db.hasAccess(SongsPage.SONGS_ADD_ACCESS);
      this.hasUpdSongsAccess = this.db.hasAccess(SongsPage.SONGS_UPD_ACCESS);
      this.hasDelSongsAccess = this.db.hasAccess(SongsPage.SONGS_DEL_ACCESS);
    }
  }

  private OnExport() {
    console.log("SongsPage OnExport");
  }

  private ionViewWillEnter() {
    console.log("SongsPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("SongsPage onInitPage");
    this.searchbar.clearInput(null);
    // let mbrDefaultOrder = this.configService.getConfig("DEFAULT_MEMBER_DISPLAY_ORDER");

    this.tmpSearchObject = this.songs$ = this.db.dbCol({
      "action": "select", "mapObject": "songs",
      "sqlExtended": " order by so_order, so_title" ,
    });
  }

  private ngOnDestroy() {
    console.log("SongsPage ngOnDestroy");
    this.songs$ = null;
  }

  private addSong() {
    console.log("SongsPage addSong");
    this.navCtrl.push(SongsAddPage);
  }

  private viewSong(song: Songs) {
    console.log("SongsPage viewSong");
    this.navCtrl.push(SongsViewPage, {
      "song": song,
     });
  }

  private search(searchbar) {
    console.log("SongsPage search" );
    let q = searchbar.target.value;

    if (q.trim() === "") {
      this.songs$ = this.tmpSearchObject;
      return;
    }
    this.songs$ = this.songs$
      .map((arrays) => arrays.filter((arrayEl) => (arrayEl.so_title.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1) ||
        (arrayEl.so_text.toLowerCase().indexOf(searchbar.target.value.toLowerCase()) > -1),
      ));
  }
}



// WEBPACK FOOTER //
// ./src/pages/songs/songs.ts